/*eslint-disable*/
import React, {useState, useEffect, Fragment} from "react";

import APIClient from "../client";
import config from "../config.js"
import TableChart from "../components/Charts/TableChart.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";
import {useForm} from "react-hook-form";


const client = new APIClient(config);


export default function AdminApiKey() {
    const {
        register: registerKey,
        formState: {errors: errors},
        handleSubmit: handleSubmit,
    } = useForm({
        mode: "onBlur",
    });

    const [data, setData] = useState(null);
    const [columnData, setColumnData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [keyStatus, setKeyStatus] = useState(null);
    const [keyError, setKeyError] = useState(null);
    const [keyMsg, setKeyMsg] = useState(null);
    const [keyDeleteStatus, setKeyDeleteStatus] = useState(null);
    const [keyDeleteError, setKeyDeleteError] = useState(null);

    useEffect(() => {
        fetchKeys();

    }, []);


    const fetchKeys = () => {
        client.getAllApiKeys().then((data) => {
            setLoading(false);
            setData(data['data']['data']);
            const columns = [
                {
                    key: "action",
                    text: "Action",
                    className: "action",
                    width: 100,
                    align: "left",
                    sortable: false,
                    cell: (record) => {
                        return (
                            <Fragment>
                                <button
                                    className="get-started text-blue rounded py-1 px-7 bg-yellow"
                                    onClick={() => {
                                        onDeleteKey(record);
                                    }}
                                >
                                    &nbsp;
                                    <i className="fa fa-minus-square-o" aria-hidden="true"></i>
                                    &nbsp; Remove Key &nbsp;
                                </button>
                            </Fragment>
                        );
                    },
                },
                {
                    name: "Api Key",
                    selector: (row) => row.key_name,
                },
                {
                    name: "id",
                    omit: true,
                    selector: (row) => row.id,
                },
            ];

            setColumnData(columns);

            setError(null);
        });
    };

    const onSubmitKey = (event) => {
        client.addApiKey(event).then((data) => {
                setKeyMsg(data['data']['hashed_key']);
                setKeyStatus("Funder Capital added.");
                setKeyError(null);
                fetchKeys();
            })
            .catch((err) => {
                setKeyError(err);
                setKeyStatus(null);
                setKeyMsg(null);
            });
    };

    const onDeleteKey = (event) => {
        client.removeApiKey(event.id).then(() => {
                setKeyDeleteStatus("User Permission removed.");
                setKeyDeleteError(null);
                fetchKeys();
            })
            .catch((err) => {
                setKeyDeleteError(err);
                setKeyDeleteStatus(null);
            });
    };


    document.title = "Key Management";


    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">

                    {loading && (
                        <div className="text-xl font-medium">Loading...</div>
                    )}
                    {error && <CardError message={error}/>}

                    {data && (
                        <>
                            <h2 className="text-36 text-yellow mb-6">Manage Api Keys</h2>

                            <section className="relative pb-20">
                                <div className="container relative mx-auto pt-12 px-4">
                                    <div className="relative md:w-12/12 lg:w-12/12 px-4 mb-1">
                                        <div className="relative bg-white-7 w-full rounded-lg p-4 mb-8">
                                            <div className="w-full flex items-center">
                                                <div className="w-3/12">
                                                    <div className="relative flex flex-col text-white w-full">
                                                        {/*<FiatGroup className="size-btc-group"/>*/}
                                                        <i className="fa fa-user-circle fa-6" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                <div className="w-9/12">
                                                    <div className="relative flex flex-col w-full px-6">
                                                        <h2 className="text-24-performance text-white">Add Api Key</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className="mb-4 bigHr"></hr>

                                            <form onSubmit={handleSubmit(onSubmitKey)}>

                                                <div className="flex flex-wrap -mx-3 mb-6">

                                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                                        <label
                                                            className="block uppercase tracking-wide text-white text-xs font-bold mb-2"
                                                            htmlFor="grid-first-name">
                                                            Key Name
                                                        </label>
                                                        <input
                                                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                            id="grid-first-name" type="text"
                                                            placeholder="my_api_key" {...registerKey("key_name")} />
                                                    </div>

                                                    <div className="w-full md:w-1/2 px-3">
                                                        <button
                                                            className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                                            type="submit"
                                                        >
                                                            <i className="fa fa-plus-square"
                                                               aria-hidden="true"></i>

                                                            &nbsp; Add Key &nbsp;
                                                        </button>
                                                        {keyStatus !== null && (
                                                            <p className="text-yellow text-sm text-center italic">Api
                                                                Key Added. Save this before its gone: <strong>{keyMsg}</strong>
                                                            </p>

                                                        )}

                                                        {keyError !== null && (
                                                            <p className="text-red-500 text-center text-sm">Error
                                                                adding Api Key.</p>
                                                        )}
                                                    </div>
                                                </div>


                                            </form>
                                        </div>

                                    </div>

                                </div>
                            </section>


                            <TableChart
                                columns={columnData}
                                data={data}
                                defaultSortFieldId={1}
                                dense
                            />


                        </>
                    )
                    }


                </div>
            </section>


        </>

    );
}


